import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

// components
import LogHistoryForm from "./_form";
import LogHistoryFilters from "./_filters";
import {ButtonTableLog} from "../../../components/buttons/buttonsActions";
import {getStateByPath} from "../../../redux/selectors";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import {
    changeListItem,
    setFilter,
    setForm,
    setItem,
    setTableParams
} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// labels
import {LB_EMPTY_TABLE, LIST} from "../../../components/i18n/i18n";

// services
import {logHistoryService} from "../../../jwt/_services/security/logHistoryService";

// utils
import {utilHelper} from "../../../jwt/_helpers";

const LogHistoryList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    // Set initial filter
    useEffect(() => {
        if (filter)
            return

        props.setFilter(path, {
            item: {
                id:null,
                userName: null,
                action: null,
                model: null,
                startDate: null,
                endDate: null
            }
        })
    }, [app, udn]);

    useEffect(() => {
        if (!filter)
            return

        genericIndexedActions.search(path, logHistoryService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(LogHistoryForm, { path, data })
    }

    const dateFormatter = (cell) =>  utilHelper.dateFormatter(cell,"DD/MM/YYYY HH:mm:ss")


    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '10%'},
            text: 'ID',
            headerAlign: 'center',
            align: 'center',
            hidden: true
        }, {
            dataField: 'registerDate',
            text: 'Fecha',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '170px'},
            formatter: dateFormatter
        }, {
            dataField: 'username',
            text: 'Usuario',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '120px'},
        }, {
            dataField: 'model',
            text: 'Modelo'
        }, {
            dataField: 'action',
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '100px'},
        }, {
            dataField: 'ipAddress',
            text: 'IP',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '100px'},
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
            formatter: (cell, row) => <ButtonTableLog onClick={() => editItem(row)}/>
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <LogHistoryFilters path={path} />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={LB_EMPTY_TABLE}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    changeListItem,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(LogHistoryList)